var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|cpf", name: "CPF" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "CPF:" } }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "CPF" },
                          model: {
                            value: _vm.pessoa.pessoaFisica.cpf,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa.pessoaFisica, "cpf", $$v)
                            },
                            expression: "pessoa.pessoaFisica.cpf"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Nome" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Nome:" } }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Nome" },
                          model: {
                            value: _vm.pessoa.pessoaFisica.nome,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa.pessoaFisica, "nome", $$v)
                            },
                            expression: "pessoa.pessoaFisica.nome"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.requiredRg.rules, name: "RG" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "RG:",
                            required: _vm.requiredRg.label
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "RG" },
                          model: {
                            value: _vm.pessoa.pessoaFisica.rg,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa.pessoaFisica, "rg", $$v)
                            },
                            expression: "pessoa.pessoaFisica.rg"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.requiredRg.rules, name: "Órgão expedidor" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Órgão expedidor:",
                            required: _vm.requiredRg.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Órgão Expedidor",
                              "no-match-text": "Nenhum Orgão Encontrado",
                              placeholder: "Selecione",
                              "value-key": "id",
                              filterable: "filterable",
                              clearable: "clearable"
                            },
                            model: {
                              value:
                                _vm.pessoa.pessoaFisica.orgaoExpedidor.nome,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoa.pessoaFisica.orgaoExpedidor,
                                  "nome",
                                  $$v
                                )
                              },
                              expression:
                                "pessoa.pessoaFisica.orgaoExpedidor.nome"
                            }
                          },
                          _vm._l(_vm.orgaosExpedidores, function(
                            orgaoExpedidor
                          ) {
                            return _c("el-option", {
                              key: orgaoExpedidor.id,
                              attrs: {
                                label: orgaoExpedidor.nome,
                                value: orgaoExpedidor.nome
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: _vm.requiredRg.rules, name: "UF do RG" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "UF do RG:",
                            required: _vm.requiredRg.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "UF do RG",
                              "no-match-text": "Nenhuma UF Encontrada",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable",
                              disabled: !_vm.pessoa.pessoaFisica.orgaoExpedidor
                                .nome
                            },
                            model: {
                              value:
                                _vm.pessoa.pessoaFisica.orgaoExpedidor.estado,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoa.pessoaFisica.orgaoExpedidor,
                                  "estado",
                                  $$v
                                )
                              },
                              expression:
                                "pessoa.pessoaFisica.orgaoExpedidor.estado"
                            }
                          },
                          _vm._l(_vm.estadosBr, function(estado) {
                            return _c("el-option", {
                              key: estado.codigo,
                              attrs: {
                                label: estado.nome,
                                value: estado.codigo
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Nacionalidade" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Nacionalidade:" } }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Nacionalidade",
                              "no-match-text":
                                "Nenhuma Nacionalidade Encontrada",
                              placeholder: "Selecione",
                              "value-key": "id",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            model: {
                              value: _vm.pessoa.pessoaFisica.nacionalidade,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoa.pessoaFisica,
                                  "nacionalidade",
                                  $$v
                                )
                              },
                              expression: "pessoa.pessoaFisica.nacionalidade"
                            }
                          },
                          _vm._l(_vm.gentilico, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.gentilico + " - " + item.nomePais,
                                value: item.sigla
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|email", name: "E-mail" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "E-mail:", rules: "required" }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "E-mail", label: "email" },
                          model: {
                            value: _vm.pessoa.pessoaFisica.email,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoa.pessoaFisica, "email", $$v)
                            },
                            expression: "pessoa.pessoaFisica.email"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "Estado civil" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Estado civil:" } }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Estado civil",
                              "value-key": "codigo",
                              "no-match-text": "Nenhum estado civil encontrado",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            model: {
                              value: _vm.pessoa.pessoaFisica.estadoCivil,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoa.pessoaFisica,
                                  "estadoCivil",
                                  $$v
                                )
                              },
                              expression: "pessoa.pessoaFisica.estadoCivil"
                            }
                          },
                          _vm._l(_vm.estadosCivil, function(item) {
                            return _c("el-option", {
                              key: item.codigo,
                              attrs: { label: item.nome, value: item.codigo }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c84e35d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c84e35d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/AppPessoaSocio.vue
// module id = null
// module chunks = 